import React, { useContext } from "react"
import { useAppSelector } from "../../../store/hooks"
import { selectCatalogsState } from "../../../store/knowledgeBase/selectors"
import Async from "../../Async/Async"
import CatalogsLoader from "../CatalogsLoader"
import ErrorMessage from "../../ErrorMessage/ErrorMessage"
import SharedCatalog from "../../Catalog/SharedCatalog/SharedCatalog"
import KnowledgeBaseContext from "../../KnowledgeBaseProvider/KnowledgeBaseContext"
import ErrorBoundary from "../../ErrorBoundary/ErrorBoundary"

interface SharedCatalogsProps {
    url: string
}

const SharedCatalogs: React.FC<SharedCatalogsProps> = props => {
    const { url } = props
    const apiState = useAppSelector(selectCatalogsState)
    const { shareId } = useContext(KnowledgeBaseContext)

    return (
        <Async
            dataState={apiState}
            processView={<CatalogsLoader itemsCount={2} />}
            errorView={({ message }) => <ErrorMessage text={message} />}
        >
            {({ data: catalogIds }) => (
                <ErrorBoundary local>
                    {catalogIds.map(
                        id =>
                            shareId && (
                                <SharedCatalog
                                    key={`${id}-shared-catalog`}
                                    id={typeof id == "string" ? id : String(id)}
                                    url={url}
                                    shareId={shareId}
                                />
                            )
                    )}
                </ErrorBoundary>
            )}
        </Async>
    )
}

export default SharedCatalogs
